import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "../../../styles/users-table.css";

export default function UsersTable({ users, onStatusChange, onDelete }) {
  const [expandedRow, setExpandedRow] = useState(null);

  if (!users || users.length === 0) {
    return <div className="text-muted text-center py-4">No users found.</div>;
  }

  const StatusBadge = ({ status }) => (
    <span
      className={`badge bg-${status === "ACTIVE" ? "success" : "secondary"}`}
    >
      {status || "UNKNOWN"}
    </span>
  );

  return (
    <div>
      {/* ================= DESKTOP TABLE ================= */}
      <div className="table-responsive d-none d-md-block">
        <table className="table table-hover align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Created At</th>
              <th style={{ width: 120 }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.fullName || "-"}</td>

                <td>{user.email || "-"}</td>

                <td>{user.phone || "-"}</td>

                <td>
                  <StatusBadge status={user.status} />
                </td>

                <td>
                  {user.createdAt
                    ? new Date(user.createdAt).toLocaleDateString()
                    : "-"}
                </td>

                <td>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      size="sm"
                      variant="outline-secondary"
                      id={`actions-${user.id}`}
                    >
                      Actions
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => onStatusChange(user)}>
                        Change Status
                      </Dropdown.Item>

                      <Dropdown.Divider />

                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => onDelete(user)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ================= MOBILE CARDS ================= */}
      <div className="d-md-none">
        {users.map((user) => {
          const isExpanded = expandedRow === user.id;

          return (
            <div key={user.id} className="card user-card shadow-sm mb-3">
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div className="user-info">
                    <div className="fw-semibold">{user.fullName || "-"}</div>

                    <div className="text-muted small text-break">
                      {user.email || "-"}
                    </div>

                    <div className="text-muted small">{user.phone || "-"}</div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setExpandedRow(isExpanded ? null : user.id)}
                  >
                    {isExpanded ? "Hide" : "View"}
                  </button>
                </div>

                {isExpanded && (
                  <div className="user-details mt-3">
                    <div className="mb-2">
                      <strong>Status:</strong>{" "}
                      <StatusBadge status={user.status} />
                    </div>

                    <div className="mb-3">
                      <strong>Created At:</strong>{" "}
                      {user.createdAt
                        ? new Date(user.createdAt).toLocaleDateString()
                        : "-"}
                    </div>

                    <Dropdown className="w-100">
                      <Dropdown.Toggle
                        size="sm"
                        variant="outline-secondary"
                        className="w-100"
                      >
                        Actions
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="w-100">
                        <Dropdown.Item onClick={() => onStatusChange(user)}>
                          Change Status
                        </Dropdown.Item>

                        <Dropdown.Divider />

                        <Dropdown.Item
                          className="text-danger"
                          onClick={() => onDelete(user)}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
